// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedClass[data-v-27b6752a] {\n  border-width: 4px;\n  border-style: solid;\n  --tw-border-opacity: 1;\n  border-color: rgba(0, 199, 86, var(--tw-border-opacity));\n}\n.mouseDownClass[data-v-27b6752a] {\n  --tw-scale-x: .95;\n  --tw-scale-y: .95;\n}\n\n/* @media (min-width: 768px) {\n  .selectedClass {\n    @apply border-4 border-green-highlight border-solid;\n  }\n} */\n", ""]);
// Exports
module.exports = exports;
